// @ts-nocheck
import React, { useContext } from 'react';
import { Router, Redirect } from '@reach/router';

import { SecondaryNav } from '../../pages/Navigation';
import { Lessons } from '../../pages/Lessons';
import { Login } from '../../pages/Login';
import { Assessment } from '../../pages/Assessment';
import { Planning } from '../../pages/Planning';
import { ProfessionalLearning } from '../../pages/ProfessionalLearning';
import { ExemplarsStage } from '../../pages/Exemplars/ExemplarsStage';
import { Exemplar } from '../../pages/Exemplars/Exemplar';
import { Layout } from '../Layout';
import { LessonPlan } from '../LessonPlan';
import { LessonsCollections } from '../../pages/Lessons/LessonsCollections';
import { LessonTextType } from '../LessonTextType';
import { Lesson } from '../Lesson';
import { PrivateRoutes } from '../PrivateRoutes';
import { AccessCode } from '../../pages/AccessCode';
import { Proforma } from '../../pages/Proformas/Proforma/Proforma';
import { NotFound } from '../../pages/NotFound';
import { AssessmentList } from '../../pages/Assessment/AssessmentList';
import { ShortUrl } from '../../pages/ShortUrl/ShortUrl';
import AuthContext from '../../contexts/authContext';
import { WRITING_PROFORMA } from '../../constants/navigation';

export const Routes = (): JSX.Element => {
  const { defaultStage } = useContext(AuthContext);

  return (
    <Router>
      <PrivateRoutes path="/" component={Layout}>
        <Redirect from="/" to="/exemplars" noThrow />
        <PrivateRoutes path="/exemplars" component={SecondaryNav}>
          <Redirect from="/" to={defaultStage} noThrow />
          <PrivateRoutes stage="emergent" path="/:stage" component={ExemplarsStage} />
          <PrivateRoutes path="/:stage/:type/:id/:screen/:page" component={Exemplar} />
          <Redirect from="/*" to="/not-found" />
        </PrivateRoutes>
        <PrivateRoutes path="/planning" component={SecondaryNav}>
          <Redirect from="/" to="scope-and-sequence" noThrow />
          <PrivateRoutes stage="scope-and-sequence" path="/:stage" component={Planning} />
          <Redirect from="/*" to="/not-found" />
        </PrivateRoutes>
        <PrivateRoutes path="/assessment" component={SecondaryNav}>
          <Redirect from="/" to={defaultStage} noThrow />
          <PrivateRoutes stage="emergent" path="/:stage" component={Assessment} />
          <PrivateRoutes path="/:stage/:categoryName/:textType" component={AssessmentList} />
          <Redirect from="/*" to="/not-found" />
        </PrivateRoutes>
        <PrivateRoutes path="/lessons" component={Lessons}>
          <PrivateRoutes path="/" component={LessonsCollections} />
          <PrivateRoutes path="collection/:collectionId" component={LessonPlan} />
          <PrivateRoutes
            path="collection/:collectionId/exemplarsRelated/:exemplarId/textType/:textTypeId"
            component={LessonTextType}
          />
          <PrivateRoutes
            path="collection/:collectionId/exemplarsRelated/:exemplarId/textType/:textTypeId/lessons/:lessonId"
            component={Lesson}
          />
          <Redirect from="/*" to="/not-found" />
        </PrivateRoutes>
        <PrivateRoutes path="/shorturl/pmw" component={ShortUrl} />
        <PrivateRoutes path="/professional" component={SecondaryNav}>
          <Redirect from="/" to="about-pm-writing" noThrow />
          <PrivateRoutes stage="about-pm-writing" path="/:stage" component={ProfessionalLearning} />
          <Redirect from="/*" to="/not-found" />
        </PrivateRoutes>
        <PrivateRoutes screen="default" path={`/:screen/${WRITING_PROFORMA}`} component={Proforma} />
        <PrivateRoutes
          type="saved_proforma"
          screen="default"
          path={`/:type/:id/:screen/${WRITING_PROFORMA}`}
          component={Proforma}
        />
        <NotFound path="/not-found" />
        <Redirect from="*" to="/not-found" noThrow />
      </PrivateRoutes>
      <PrivateRoutes path="/accesscode" component={AccessCode} key="access-code" />
      <Login path="/login" />
    </Router>
  );
};
